import { ConfigTabNav, type ConfigTabItem } from '@/components/layout/ConfigTabNav';

const tabs: ConfigTabItem[] = [
  {
    value: 'orgFunctions',
    labelKey: 'common.Sidebar.MyOrgFunctions',
    to: '/$slug/org-functions',
    requiredPermission: { subject: 'MyOrgFunctions' }
  },
  {
    value: 'department',
    labelKey: 'common.Sidebar.MyDepartment',
    to: '/$slug/department',
    requiredPermission: { subject: 'MyDepartment' }
  },
  {
    value: 'organigram',
    labelKey: 'common.Sidebar.OrgChart',
    to: '/$slug/organigram',
    requiredPermission: { subject: 'OrgChart' }
  }
];

export function WorkEnvironmentTabsNav() {
  return <ConfigTabNav tabs={tabs} />;
}
